// AlpineJS drives everything interactive in this theme. It is imported first so
// that the components below can register on `alpine:init` before it starts.
import AlpineJS from "./../../node_modules/alpinejs/dist/cdn";

import registerCarousel from "./components/Carousel";
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

registerCarousel();

// No jQuery: the theme's own JavaScript is plain DOM API. jQuery is still on the
// page because Gravity Forms enqueues it, but nothing here waits for it.
document.addEventListener("DOMContentLoaded", () => {
    ReplaceObfuscatedEmailAddresses.init();
    AnimateOnPageLinks.init();
});
